import { render } from "./stat4.vue?vue&type=template&id=6661d9c3"
import script from "./stat4.vue?vue&type=script&lang=js"
export * from "./stat4.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__